export const Pokemons = [
    {name: 'Ivysaur', usdtPrice: 71, image: './assets/0849Toxtricity.png'},
    {name: 'Toxtricity', usdtPrice: 42, image: './assets/0007Squirtle.png'},
    {name: 'Eevee', usdtPrice: 87, image: './assets/0009Blastoise.png'},
    {name: 'Squirtle', usdtPrice: 19, image: './assets/0094Gengar.png'},
    {name: 'Blastoise', usdtPrice: 22, image: './assets/0133Eevee.png'},
    {name: 'Gengar', usdtPrice: 63, image: './assets/0002Ivysaur.png'}
]